import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  title: {
    textTransform: 'uppercase',
    flexGrow: 1,
  },
  radioContainer: {
    textAlign: 'center',
  },
  form: {
    paddingTop: theme.spacing(2),
  },
}));
